import EnhancedSidebar from './EnhancedSidebar'

interface SidebarProps {
  isCollapsed?: boolean
  onToggle?: () => void
}

export default function Sidebar({ isCollapsed, onToggle }: SidebarProps) {
  return <EnhancedSidebar isCollapsed={isCollapsed} onToggle={onToggle} />
}